var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-data-iterator",
    _vm._b(
      {
        staticClass: "base-data-grid",
        attrs: {
          "footer-props": { itemsPerPageOptions: _vm.itemsPerPageOptions },
          "hide-default-footer": _vm.footerSlotInUse,
          "items-per-page": _vm.itemsPerPage,
          "must-sort": "",
        },
        scopedSlots: _vm._u(
          [
            _vm.$slots.toolbar || _vm.$scopedSlots.toolbar
              ? {
                  key: "header",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "base-data-grid__toolbar d-flex justify-center align-center",
                            },
                            [_vm._t("toolbar", null, null, slotProps)],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "loading",
              fn: function () {
                return [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "base-data-grid__loading d-flex justify-center align-center",
                        },
                        [
                          _vm.$slots.loading
                            ? _vm._t("loading")
                            : [
                                _c("v-progress-circular", {
                                  attrs: {
                                    color: "primary",
                                    indeterminate: "",
                                    size: "64",
                                    width: "8",
                                  },
                                }),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "no-data",
              fn: function () {
                return [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "base-data-grid__no-data d-flex justify-center align-center",
                        },
                        [
                          _vm.$slots["no-data"]
                            ? _vm._t("no-data")
                            : [
                                _c(
                                  "v-alert",
                                  { staticClass: "px-12", attrs: { text: "" } },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.$vuetify.noDataText) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "no-results",
              fn: function () {
                return [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "base-data-grid__no-results d-flex justify-center align-center",
                        },
                        [
                          _vm.$slots["no-results"]
                            ? _vm._t("no-results")
                            : [
                                _c(
                                  "v-alert",
                                  { staticClass: "px-12", attrs: { text: "" } },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$vuetify.dataIterator
                                            .noResultsText
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "default",
              fn: function (slotProps) {
                return [
                  slotProps && slotProps.items && slotProps.items.length
                    ? _c(
                        "v-row",
                        { staticClass: "base-data-grid__items-row" },
                        _vm._l(slotProps.items, function (item) {
                          return _c(
                            "v-col",
                            _vm._b(
                              {
                                key: item[_vm.$attrs.itemKey],
                                staticClass: "base-data-grid__items-col",
                              },
                              "v-col",
                              _vm.itemVColProps,
                              false
                            ),
                            [_vm._t("item", null, null, item)],
                            2
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
            _vm.$slots.footer || _vm.$scopedSlots.footer
              ? {
                  key: "footer",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "base-data-grid__footer d-flex justify-center align-center",
                            },
                            [_vm._t("footer", null, null, slotProps)],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
      },
      "v-data-iterator",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }